<template>
  <div>
    <v-toolbar flat>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-form-card
      v-if="dataReady"
      :dObject="data_object"
      v-bind="schema['v-bind']"
      ref="form"
      :panels="true"
      :key="formKey"
      :submit_button_caption="submitCaption"
      :actionFixedPosition="true"
    ></v-form-card>
  </div>
</template>

<script>
import * as fun from "../plugins/common";

import axios from "axios";
export default {
  name: "StorageDetail",
  components: {
    VFormCard: () => import("../components/FormCard.vue"),
  },

  data() {
    return {
      dataReady: false,
      customerRecord: true,
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      data_object: {
        object_name: "v_customer_orders",
        object_name_to_update: "customer",
      },
      id: "",
      submitCaption: "Save",
    };
  },
  mounted() {
    this.$root.$on("tableMounted", (t) => {
      // console.log(t.k);
      if (t.k == "customer_shipments") {
        t.link = that.link;
        t.myLinkClick = that.linkClick;
      }
    });
    var that = this;
    this.id = this.$route.params.id.toString();
    this.refresh();
    this.$root.$on("tableChanged", (tbl, keys) => {
      // console.log(tbl);
      if (tbl.tableName == "inventory" && that.model) {
        that.model.inventory = tbl.originalRecords;
        that.calculateInventoryVolume();
      }
    });
  },
  beforeDestroy() {},
  methods: {
    refreshData() {
      this.data.additional_data = [
        {
          obj_name: "v_shipment_letter_fields",
          qry: { "customer._id": this.id },
          id_fields: ["customer._id"],
        },
        {
          obj_name: "storage",
          qry: { customer: this.id },
          id_fields: ["customer"],
        },
      ];
      var that = this;
      axios
        .post(this.serverURL + "/get_data", this.data, {
          withCredentials: true,
        })
        .then((response) => {
          that.data_object = response.data;
          that.data_object.objectName = "v_customer_orders";
          that.data_object.object_name_to_update = "customer";
          that.data_object.fields_to_exclude = ["customer_shipments"];
          that.data_object.model.address = that.data_object.model.address.filter(
            (a) => {
              return !a.existing_address && a.location && a.location.address;
            }
          );
          this.data_object.model.customer_shipments =
            that.data_object.additional_model.v_shipment_letter_fields;
          this.data_object.model.storage =
            that.data_object.additional_model.storage;
          this.data_object.model.customer_shipments.forEach((s) => {
            s.origin_city = s.origin.city;
            s.origin_state = s.origin.state;
            s.origin_zip = s.origin.state;
            s.destination_city = s.destination.city;
            s.destination_state = s.destination.state;
            s.destination_zip = s.destination.zip;
            // s.first_name = t.rec.first_name;
            // s.last_name = t.rec.last_name;
            // s.full_name = t.rec.full_name;
            // s.company = t.rec.company;
          });
          this.schema = response.data.schema;
          this.dataReady = true;
          this.formKey = !this.formKey;
        });
    },

    refresh(reload) {
      this.id = this.$route.params.id.toString().split(":")[0];
      this.data = {
        object_name: "v_customer_orders",
        single_record: true,
        qry: {
          _id: this.id,
        },
        portal_id: this.$session.get("portal_id"),
      };
      // this.sid = this.$route.params.id.toString().split(":")[1];

      this.refreshData(reload);
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
  },
};
</script>

<style lang="css" scoped></style>
